module.exports = __webpack_public_path__ + "img/frame (41).23944531.jpg";